import {
  Box,
  DropButton,
  Heading,
  Text,
  Anchor,
  Card,
  CardHeader,
  Button,
  CardBody,
  Paragraph,
  Stack,
  Avatar
} from 'grommet'
import React from 'react'
import PropTypes from 'prop-types'
import { AppContext, AuthContext } from '../libs/context'
import { FormClose, Link, ShareRounded } from 'grommet-icons'
import Cookies from 'js-cookie'
import { Route, Redirect } from 'react-router-dom'
import { BarLoader, PropagateLoader } from 'react-spinners'
import { brandColors, meshTheme } from '../libs/theme'
import { MotionBox } from './Motion'
import MoonLoader from 'react-spinners/MoonLoader'
import { AnimatePresence } from 'framer-motion'

export const PrivateRoute = ({ component: Component, componentProps = {}, ...rest }) => (
  <AuthContext.Consumer>
    {({ authUser }) => (
      <Route
        {...rest}
        render={(props) =>
          authUser || Cookies.get('userToken') ? (
            <Component {...props} {...componentProps} />
          ) : (
            <Redirect to="/login" />
          )
        }
      />
    )}
  </AuthContext.Consumer>
)
export const LoadingHeader = ({
  loader = 'bar',
  loading,
  color = 'dark-6',
  size = '4px',
  ...boxProps
}) => {
  return (
    <Box
      // background={loading ? 'light-4' : undefined}
      fill="horizontal"
      flex={false}
      height={size}
      align={'center'}
      justify={'center'}
      {...boxProps}
    >
      {loader === 'propagate' && (
        <PropagateLoader
          loading={loading}
          size={size}
          color={meshTheme.global.colors[color]}
          width={'100%'}
        />
      )}
      {loader === 'bar' && (
        <BarLoader
          loading={loading}
          height={size}
          color={meshTheme.global.colors[color]}
          width={'100%'}
        />
      )}
    </Box>
  )
}
export const PageHeader = ({ heading, children, direction = 'row', ...rest }) => (
  <Box
    direction={direction}
    background="light-1"
    height={direction === 'row' && '70px'}
    // elevation="large"
    flex={false}
    border={{ side: 'bottom', color: 'light-4' }}
    // round="small"
    gap={direction == 'row' ? 'medium' : 'small'}
    pad="small"
    justify={'center'}
    align={'center'}
    {...rest}
  >
    {heading && (
      <Heading level={4} color={'mesh-purple-1'} margin="none">
        {heading}
      </Heading>
    )}
    {children}
  </Box>
)
PageHeader.propTypes = {
  heading: PropTypes.string
}
export const DropWithHeading = ({ heading, children, ...rest }) => (
  <DropButton
    hoverIndicator
    color={'light-3'}
    size={'small'}
    dropProps={{ elevation: 'xlarge' }}
    dropContent={
      <Box pad={'medium'} gap={'small'}>
        <Text color="dark-6" weight="bold" size="small" margin={'none'}>
          {heading.toUpperCase()}
        </Text>
        <Box height={'2px'} border={{ side: 'bottom' }} />
        {children}
      </Box>
    }
    {...rest}
  />
)
DropWithHeading.propTypes = {
  heading: PropTypes.string
}
/*
 * Assumes it is being used in GeneratedFile or PublishFile component to render row details
 * **/
export const FileDataRowDetails = ({ ...row }) => {
  const isDataAnArray = (row, key) => {
    let comp = null
    if (Array.isArray(row[key])) {
      row[key].forEach((valueRow) => {
        console.log(valueRow)
        if (typeof valueRow === 'object') {
          comp = <FileDataRowDetails {...valueRow} />
        } else {
          comp = (
            <Text color={'dark-3'} truncate>
              {valueRow}
            </Text>
          )
        }
      })
    } else {
      comp = (
        <Text color={'dark-3'} truncate>
          {row[key]}
        </Text>
      )
    }
    return comp
  }
  return (
    <AppContext.Consumer>
      {({ companies, receivers, stores }) => (
        <Box
          gap="small"
          flex={'grow'}
          align={'start'}
          pad={'medium'}
          background={'light-2'}
          round={'xsmall'}
          elevation={'medium'}
        >
          {row.company_id && companies[row.company_id] && (
            <Heading level={3} margin="xxsmall" weight={'bold'} color={'mesh-green-1'}>
              {companies[row.company_id].name}
            </Heading>
          )}
          {row.store_id && stores[row.store_id] && (
            <Heading level={5} margin="xxsmall" weight={'bold'} color={'mesh-green-2'}>
              {stores[row.store_id].name}
            </Heading>
          )}
          {row.receiver_id && receivers[row.receiver_id] && (
            <Heading level={3} margin="xxsmall" color={'mesh-purple-1'} weight={'bold'}>
              {receivers[row.receiver_id].name}
            </Heading>
          )}
          {Object.keys(row).map((key) => (
            <Box key={key} direction={'row'}>
              <Box width={'small'}>
                <Text weight={'bold'} color={'dark-6'}>
                  {key}
                </Text>
              </Box>
              <Box>
                {key === 'vUri' ? (
                  <Anchor
                    color={'dark-3'}
                    icon={<ShareRounded size={'16px'} />}
                    label="Go to url"
                    href={row[key]}
                    target={'_blank'}
                  />
                ) : (
                  isDataAnArray(row, key)
                )}
              </Box>
            </Box>
          ))}
        </Box>
      )}
    </AppContext.Consumer>
  )
}

export const SplitterLine = ({ text, color = 'light-5', ...borderProps }) => (
  <Box
    align="center"
    gap="medium"
    justify="center"
    fill="horizontal"
    height="xxsmall"
    direction={'row'}
  >
    <Box
      fill={'horizontal'}
      height={'2px'}
      border={{ side: 'bottom', color: color }}
      {...borderProps}
    />
    <Text size={'xsmall'} color={color}>
      {text}
    </Text>
    <Box
      fill={'horizontal'}
      height={'2px'}
      border={{ side: 'bottom', color: color }}
      {...borderProps}
    />
  </Box>
)
export const SplashLoader = ({
  authUser,
  apiLoading,
  message = 'Grabbing some digital bits...'
}) => (
  <AnimatePresence>
    <MotionBox
      align={'center'}
      gap={'small'}
      initial={{ opacity: 0, x: 100 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, scale: 0 }}
      transition={{ type: 'spring', duration: 0.7 }}
    >
      <Stack anchor={'center'} guidingChild={'last'}>
        <Avatar src={authUser.photoURL} />
        <Box align="center" justify="center" width={'small'} height={'small'}>
          <MoonLoader color={brandColors['mesh-purple-1']} loading={apiLoading} size={60} />
        </Box>
      </Stack>
      <Heading margin="none" color={'mesh-purple-1'} level={2}>
        Welcome {authUser.displayName ? authUser.displayName : authUser.email}
      </Heading>
      <Text size={'small'} weight="bold" color={'dark-6'}>
        {message}
      </Text>
    </MotionBox>
  </AnimatePresence>
)

export const RoundIconButton = ({
  Icon,
  onClick,
  color = 'dark-6',
  elevation = undefined,
  href,
  round = 'full',
  background,
  ...rest
}) => (
  <Box
    height={'xxsmall'}
    width={'xxsmall'}
    align={'center'}
    justify={'center'}
    flex={false}
    focusIndicator={false}
    hoverIndicator
    round={round}
    onClick={onClick}
    elevation={elevation}
    background={background}
  >
    {href ? (
      <Anchor target="_blank" href={href} icon={<Icon color={color} {...rest} />} />
    ) : (
      <Icon color={color} {...rest} />
    )}
  </Box>
)

// ConditionalWrapper from: https://blog.hackages.io/conditionally-wrap-an-element-in-react-a8b9a47fab2
export const ConditionalWrapper = ({ condition, wrapper, children }) => (
  <AnimatePresence initial={true}>{condition ? wrapper(children) : children}</AnimatePresence>
)
